import React, { useRef, useEffect, useContext } from "react";

import {
  AddCard,
  Comment,
  Work,
  AccessTime,
  Delete,
  CancelPresentation,
  CheckBox,
} from "@mui/icons-material";

import {
  Button,
  Card,
  CardContent,
  CardActions,
  Alert,
  Box,
} from "@mui/material/";

import { CustomIcons } from "../../../Components/helpers/Helpers";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
import { PermissionContext } from "../../../Components/Context/Context";

const NotesTab = ({
  addDataTab,
  setAddDataTab,
  editDataTab,
  setEditDataTab,
  Editor,
  editorState,
  onEditorChange,
  handleCancelDataTabs,
  handleSubmitDataTabs,
  dataCaseNotesAlertsMessages,
  handleDeleteDataTabs,
  setSelectionStyleNote,
  selectionStyleNote,
}) => {
  const { can } = useContext(PermissionContext);
  const canDeleteNotes = can("cases", "deletenotes");
  const canAddNotes = can("cases", "addnotes");
  const editorWrapperRef = useRef(null);

  const CardNotes = ({
    lawyer,
    createdAt,
    message,
    noteId,
    noteLawyerId,
    noteCaseId,
  }) => {
    return (
      <Card
        sx={{
          minWidth: 275,
          color: "#676a6c",
          boxShadow: "-5px 3px 10px -1px #0000ff52 !important",
        }}>
        <CardContent className="alignItemsAndLeft">
          <Comment
            color="info"
            sx={{ marginRight: "10px" }}
            className="alignItemsAndLeft"
          />
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </CardContent>

        <CardActions
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            background:
              "linear-gradient(to right, #cee2fa 0%, #cee2fa 30%, transparent 80%)",

            padding: "0px 16px",
          }}>
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <Work />
            {lawyer && !lawyer.includes("undefined") ? lawyer : ""}

            <AccessTime />
            {createdAt}
          </div>

          {/* Botones opcionales */}
          {!editDataTab && (
            <div>
              {/* <Button
                 color="info"
                 size="small"
                 onClick={() => {
                   setEditDataTab(true);
                   setAddDataTab(true);
                   setNoteId(noteId);
                   setSelectionStyleNote(noteId);
                   setNoteLawyerId(noteLawyerId);
                   setNoteCaseId(noteCaseId);
                   handleEditEditorDataTabs(message);
                 }}
               >
                 <Edit />
                 Editar
               </Button> */}
              {canDeleteNotes && (
                <Button
                  color="error"
                  size="small"
                  onClick={() =>
                    handleDeleteDataTabs(noteId, message, "notes", "nota")
                  }>
                  <CustomIcons
                    icon={Delete}
                    width={"20px"}
                    height={"20px"}
                    marginRight={"5px"}
                  />
                  <span className="reOrderTextButton">Eliminar</span>
                </Button>
              )}
            </div>
          )}
        </CardActions>
      </Card>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        editorWrapperRef.current &&
        !editorWrapperRef.current.contains(event.target)
      ) {
        console.log(event.target);
        console.log(document.activeElement);

        if (document.activeElement) {
          document.activeElement.blur();
          event.target.click();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box>
      {/* ============================
          EDITOR (IZQUIERDA)
      ============================ */}
      <Box sx={{ textAlign: "right", marginY: "10px" }}>
        {addDataTab != true && editDataTab != true && canAddNotes && (
          <CustomButtonPlusIcon
            color={"info"}
            icon={AddCard}
            text={"Agregar Nota"}
            handleFunction={() => setAddDataTab(true)}
            position="start"
            variant={"contained"}
          />
        )}
      </Box>

      <Box sx={{ background: "white" }}>
        {addDataTab ? (
          <div style={{ marginBottom: "10px", padding: "10px" }}>
            <div
              ref={editorWrapperRef}
              style={{
                border: "1px solid #ddd",
                padding: "5px",
                minHeight: "160px",
                marginBottom: "10px",
                padding: "10px",
              }}>
              <Editor
                editorState={editorState}
                onEditorStateChange={onEditorChange}
                toolbar={{
                  options: [
                    "inline",
                    "fontSize",
                    "list",
                    "textAlign",
                    "history",
                  ],
                }}
              />
            </div>

            {(editDataTab || addDataTab) && (
              <div
                style={{
                  textAlign: "end",
                  marginBottom: "20px",
                  gap: 20,
                  display: "flex",
                  justifyContent: "end",
                }}>
                {addDataTab && !editDataTab && (
                  <CustomButtonPlusIcon
                    color={"error"}
                    icon={CancelPresentation}
                    text={"Cancelar Nota"}
                    handleFunction={() => handleCancelDataTabs(false)}
                    position="start"
                    variant={"outlined"}
                  />
                )}

                {editDataTab && (
                  <CustomButtonPlusIcon
                    color={"error"}
                    icon={CancelPresentation}
                    text={"Cancelar Edición"}
                    handleFunction={() => handleCancelDataTabs(false)}
                    position="start"
                    variant={"outlined"}
                  />
                )}

                <CustomButtonPlusIcon
                  color={"success"}
                  icon={CheckBox}
                  text={editDataTab ? "GUARDAR EDICIÓN" : "GUARDAR NOTA"}
                  handleFunction={() => handleSubmitDataTabs("notes", "Nota")}
                  position="start"
                  variant={"contained"}
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </Box>

      {/* ============================
            NOTAS (DERECHA)
      ============================ */}
      <Box
        sx={{
          maxHeight: "700px",
          overflowY: "auto",
          background: "white",
          borderRadius: "4px",
          padding: "10px",
        }}>
        {dataCaseNotesAlertsMessages?.notes?.length > 0 ? (
          dataCaseNotesAlertsMessages?.notes?.map((element, index) => (
            <li
              key={index}
              style={{
                listStyle: "none",
                padding: "5px",
              }}>
              <CardNotes
                noteCaseId={element.case_id}
                noteLawyerId={element.lawyer_relation?.id}
                lawyer={
                  element.lawyer_relation?.name +
                  " " +
                  element.lawyer_relation?.surname
                }
                createdAt={element.date}
                message={element.message}
                noteId={element.id}
              />
            </li>
          ))
        ) : (
          <Alert severity="info">Sin notas para mostrar</Alert>
        )}
      </Box>
    </Box>
  );
};

export default NotesTab;
